import { useQuery } from '@tanstack/react-query';

import { Query } from './api';

export const useLoginOAuthAuthorize = (provider) => {
  return useQuery({
    queryKey: ['loginOAuth', provider],
    queryFn: async () => {
      if (provider == 'email') return null;
      return await new Query(`login/oauth/${provider}/authorize`).run();
    },
    staleTime: 10,
  });
};
